import programBgImg from "../Programing/assets/bgimg.png";
import Rani from "./assets/Rani.png";
import BhagyashreeKarale from "./assets/BhagyashreeKarale.png";

export const whoForPoints = [
    { point: "Youth above 16 years of age from underprivileged or low-income communities who can't afford expensive college education" },
    { point: "No prior education needed: Our students have been school and college dropouts, 10th or 12th pass as well as degree holders such as BSc, BTech who could not get jobs" },
    { point: "Anyone from low-income families of less than 15,000 INR in urban areas and 10,000 INR in rural areas" },
    { point: "Some level of English is good to have" },
    { point: "Have heard about programming or have an interest in making a career in this field" }
];
export const whatLearnPoints = [
    { subtitle: "Front-end development:", text: "Web and Mobile development in Javascript, React.js, and Android" },
    { subtitle: "Back-end development:", text: "Python, Node.js, Javascript" },
    { subtitle: "Soft skills:", text: "English speaking, teamwork, emotional intelligence, and leadership skills" },
    { subtitle: "Hands-on projects:", text: "Clone projects for products such as WhatsApp and Facebook" }
]
export const JobAssistanceData = [
    {
        JobAssistanceContent: "Students will get 100% assistance for securing job in roles such as entry-level Software Developer, Front-End Developer, Back-End Developer, Python Developer, JavaScript Developer, Testing & QA engineer",
    }
]


export const program1Data = [

    {
        buttonText: "Stage 1",
        cardTitle: "Screening Test",
        cardText: "Assess fundamental skills up to 8th standard level in Mathematics, Logical Reasoning, and English Language.",
        format: "Online/Offline",
        eligibility: "Student from any stream",
        testStructure: { Maths: "20 marks", English: "10 marks", Total: "30 mark" },
        passingCriteria: { Maths: "14 marks", English: "6 marks" }
    },
    {
        buttonText: "Stage 2",
        cardTitle: "Academic Interview",
        cardText: "Evaluates 8th standard-level Math and English, similar to the screening test",
        format: "Online",
        eligibility: "Candidates qualifying the screening test."
    },
    {
        buttonText: "Stage 3",
        cardTitle: "Culture Fit Round",
        cardText: "Assess cultural alignment, focusing on needs, emotional aspects, and commitment to community",
        format: "Online/Offline",
        eligibility: "Successful candidates from the academic interview",
        additionalInfo: "Candidates are either marked 'Failed' or 'In Preparation'. Depending on which re-interview is allowed in 7 to 15 days"
    },
    {
        buttonText: "Stage 4",
        cardTitle: "Offer Letter",
        cardText: "Confirms selection for residential course",
        format: "Online/Offline",
        eligibility: "Candidates passing the culture-fit round.",
        confirmation: "Sent via email"
    }
];


export const DownloadData = [
    {
        id: 1,
        pdfFile:"/Pdfs/SoPCurriculum.pdf"
    }
];


export const backgroundData = [
    {
        title: "School of Programming",
        urlImg: programBgImg,
        text: "Ever dreamed of building the next big app? Unlock your potential to code for digital world, Learn front-end & back-end development to turn your creativity into real-life projects.",
        color: "white",
        buttonText: "Take Screening Test"


    }
]


export const AnumnusPageData = [
    {
        id: 1,
        name: "Bhagyashree Karale",
        img: BhagyashreeKarale,
        linkdin: "https://www.linkedin.com/in/bhagyashreekarale/",
        bioData: "NavGurukul transformed my life. Coming from a humble background, I was determined to break free from an unhealthy environment and support my family. At NavGurukul, I learned Python and JavaScript, embraced peer learning, and secured an internship with NatWest within four months. Today, I work at an MNC, earning more than my family's combined income. Beyond financial gains, NavGurukul's greatest impact is the social change it inspires, encouraging girls like me to pursue their dreams and make a difference.",
    },
    {
        id: 2,
        name: "Rani Pandit",
        bioData: "NavGurukul empowered me to transform my life. Coming from a struggling family in Bihar, we moved to Delhi in search of better opportunities but continued to face hardships. NavGurukul's new girls’ campus was my chance to escape an uncertain future. I learned coding, gained independence, and secured my first job at 18. Now, I work for BetterWorks, a US-based company, supporting my family and changing their mindset about education and opportunities for women. NavGurukul made me independent and capable of achieving my dreams.",
        img: Rani,
        linkdin: "https://www.linkedin.com/in/rani-pandit-108102158/"
    },
    
]


